import React from 'react';
import { BaseModal } from '../../components';
import { Button, withStyles } from '@material-ui/core';
import { red } from '@material-ui/core/colors';

export const AnnulJobModal = ({ handleClose, open, onSubmit }) => {
  const ColorButton = withStyles((theme) => ({
    root: {
      color: theme.palette.getContrastText(red[700]),
      backgroundColor: red[700],
      '&:hover': {
        backgroundColor: red[900],
        borderColor: red[900],
      },
      borderColor: red[900],
    },
  }))(Button);

  return (
    <BaseModal
      handleClose={handleClose}
      isOpen={open}
      title={'Confirm Trade Removal'}
      description={
        'This will mark the job as annulled and remove it from the table. This is typically performed when a speakeasy job has been queued for a user whose account does not have MFA enabled or when a job is no longer required'
      }
      customPrimaryAction={
        <ColorButton color="primary" onClick={onSubmit}>
          {'Remove Trade'}
        </ColorButton>
      }
      customSecondaryAction={
        <Button variant="outlined" color="primary" onClick={handleClose}>
          {'Cancel'}
        </Button>
      }
    />
  );
};
